import React from 'react';
import '../assets/css/style.css';

const ErrorPopup = ({ message, isOpen, onClose, type = 'error' }) => {

    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
        <div className={`popup-contain ${type}`}>
            <div className="popup-header">
                <h3>{type === 'error' ? 'Error' : 'Notification'}</h3>
                <button className="close-button" onClick={onClose}>×</button>
            </div>
            <div className="popup-content">
                <div className="popup-icon">
                    {type === 'error' ? (
                    <i className="bi bi-exclamation-circle"></i>
                    ) : (
                    <i className="bi bi-info-circle"></i>
                    )}
                </div>
                <p>{message}</p>
            </div>
            <div className="popup-footer">
                <button className="popup-button" onClick={onClose}>OK</button>
            </div>
        </div>
        </div>
    );
};

export default ErrorPopup;


// import React from 'react';
// import '../assets/css/style.css';
// import { useNavigate } from 'react-router-dom';

// const ErrorPopup = ({ message, isOpen, onClose, type = 'error' }) => {
//     const navigate = useNavigate();

//     if (!isOpen) return null;

//     const handleClose = () => {
//         onClose();
        
//         // If the error type is critical, navigate to home page
//         if (type === 'critical') {
//             navigate('/');
//         }
//     };

//     return (
//         <div className="popup-overlay">
//             <div className={`popup-contain ${type}`}>
//                 <div className="popup-header">
//                     <h3>{type === 'error' ? 'Error' : 'Notification'}</h3>
//                     <button className="close-button" onClick={handleClose}>×</button>
//                 </div>
//                 <div className="popup-content">
//                     <div className="popup-icon">
//                         {type === 'error' ? (
//                             <i className="bi bi-exclamation-circle"></i>
//                         ) : (
//                             <i className="bi bi-info-circle"></i>
//                         )}
//                     </div>
//                     <p>{message}</p>
//                 </div>
//                 <div className="popup-footer">
//                     <button className="popup-button" onClick={handleClose}>OK</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ErrorPopup;